import { NativeDataFetcher } from "@sitecore-jss/sitecore-jss-nextjs";
import {
  TravelTimeDistanceMatrixResponse,
  TravelTimeDistanceMatrixArgs,
  TravelTimeDistanceMatrixResponseResult,
  TravelTimeDistanceMatrixRequestDestination,
  TravelTimeDistanceMatrixRequestLocation,
} from "../../types/travel-time-types";

export const getDistanceMatrix = async (
  args: TravelTimeDistanceMatrixArgs
): Promise<TravelTimeDistanceMatrixResponseResult[] | null> => {
  const fetcher = new NativeDataFetcher({
    headers: [
      ["Content-Type", "application/json"],
      ["X-Application-Id", process.env.TravelTimeAppId ?? "TravelTimeAppId"],
      ["X-Api-Key", process.env.TravelTimeAppKey ?? "TravelTimeAppKey"],
    ],
  });

  const data = {
    locations: buildLocations(args),
    departure_searches: [
      buildDrivingDestination(args),
      buildWalkingDestination(args),
    ],
  };

  return await fetcher
    .post<TravelTimeDistanceMatrixResponse>(
      `https://api.traveltimeapp.com/v4/time-filter`,
      data
    )
    .then((response) => {
      if (response.data.results.length) {
        return response.data.results;
      }

      return null;
    })
    .catch((e) => {
      console.log(e);
      return null;
    });
};

const buildDrivingDestination = (
  args: TravelTimeDistanceMatrixArgs
): TravelTimeDistanceMatrixRequestDestination => {
  const arrivalIds: string[] = args.destinations.map((place) => {
    return place.id;
  });

  const result: TravelTimeDistanceMatrixRequestDestination = {
    id: `origin ${args.origin.id} driving`,
    departure_location_id: args.origin.id,
    arrival_location_ids: arrivalIds,
    departure_time: args.departureTime.toISOString(),
    travel_time: args.drivingTime,
    properties: ["travel_time", "distance"],
    transportation: {
      type: "driving",
    },
  };

  return result;
};

const buildWalkingDestination = (
  args: TravelTimeDistanceMatrixArgs
): TravelTimeDistanceMatrixRequestDestination => {
  const arrivalIds: string[] = args.destinations.map((place) => {
    return place.id;
  });

  const result: TravelTimeDistanceMatrixRequestDestination = {
    id: `origin ${args.origin.id} walking`,
    departure_location_id: args.origin.id,
    arrival_location_ids: arrivalIds,
    departure_time: args.departureTime.toISOString(),
    travel_time: args.walkingTime,
    properties: ["travel_time", "distance"],
    transportation: {
      type: "walking",
    },
  };

  return result;
};

const buildLocations = (
  args: TravelTimeDistanceMatrixArgs
): TravelTimeDistanceMatrixRequestLocation[] => {
  const result: TravelTimeDistanceMatrixRequestLocation[] = [
    {
      id: args.origin.id,
      coords: {
        lat: args.origin.location?.latitude ?? 0,
        lng: args.origin.location?.longitude ?? 0,
      },
    },
  ];

  args.destinations.forEach((place) => {
    result.push({
      id: place.id,
      coords: {
        lat: place.location.latitude,
        lng: place.location.longitude,
      },
    });
  });

  return result;
};
